import { Injectable } from '@angular/core';
import { ApiHttpClient } from 'app/http/clients/api';
import { Contact } from 'app/models/dto/contact.model';
import { ContactRelationship } from 'app/models/dto/contact-relationship.model';
import { ErcContact } from 'app/models/dto/erc-contact.model';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { DataListItem } from 'app/erc-application/erc-custom-values/erc-custom-smart-values/erc-custom-values-smart.component';

@Injectable({
  providedIn: 'root'
})
export class ContactService {

  baseUrl = environment.API_URL;

  constructor(private http: ApiHttpClient) {
    this.baseUrl = environment.API_URL;
  }

  forBorrower(borrowerId: number): Observable<Contact[]> {
    return this.http.get<Contact[]>(`${this.baseUrl}/borrower/${borrowerId}/contacts`);
  }

  forBorrowerContactOwnerRelationships(borrowerId: number): Observable<ContactRelationship[]> {
    return this.http.get<ContactRelationship[]>(`${this.baseUrl}/contacts-family/related-owners/borrower/${borrowerId}`);
  }

  forBorrowerContactEmployeeRelationships(borrowerId: number): Observable<ContactRelationship[]> {
    return this.http.get<ContactRelationship[]>(`${this.baseUrl}/contacts-family/related-employees/borrower/${borrowerId}`);
  }

  forBorrowerErcContacts(borrowerId: number): Observable<ErcContact[]> {
    return this.http.get<ErcContact[]>(`${this.baseUrl}/borrower/${borrowerId}/contacts/erc`);
  }

  delete(contactId: number): Observable<any> {
    return this.http.delete<any>(`${this.baseUrl}/contact/${contactId}`);
  }

  update(contact: Contact): Observable<Contact> {
    return this.http.put<Contact>(`${this.baseUrl}/contact/${contact.id}`, contact);
  }

  updateErcContactOwnership(ercContact: ErcContact): Observable<ErcContact> {
    return this.http.put<ErcContact>(`${this.baseUrl}/contact/${ercContact.contactId}/erc-contact`, ercContact);
  }

  updateContactRelationship(contactEmployeeRelationship: ContactRelationship) {
    const url = `${this.baseUrl}/contacts-family/related-owners/${contactEmployeeRelationship.id}`;
    return this.http.put<ContactRelationship>(url, contactEmployeeRelationship);
  }

  createContactEmployeeRelationship(contactEmployeeRelationship: ContactRelationship, borrowerId: number) {
    const url = `${this.baseUrl}/contacts-family/related-employees/borrower/${borrowerId}`;
    return this.http.post<ContactRelationship>(url, contactEmployeeRelationship);
  }

  createContactOwnerRelationship(contactEmployeeRelationship: ContactRelationship, borrowerId: number) {
    const url = `${this.baseUrl}/contacts-family/related-owners/borrower/${borrowerId}`;
    return this.http.post<ContactRelationship>(url, contactEmployeeRelationship);
  }

  deleteContactRelationship(contactEmployeeRelationship: ContactRelationship) {
    return this.http.delete<any>(`${this.baseUrl}/contacts-family/${contactEmployeeRelationship.id}`);
  }

  ercContactToDataList(ercContacts): DataListItem[] {
    return ercContacts.reduce((dataListErcContacts: DataListItem[], ercContact: ErcContact) => {
      if (!!ercContact.percentOwnership) {
        dataListErcContacts.push({
          label: `${ercContact.first} ${ercContact.last}`,
          value: ercContact.percentOwnership,
          alias: ercContact.contactId.toString(),
          sectionType: 'owners',
          metadata: {
            pipe: 'percent',
          }
        });
      }
      return dataListErcContacts;
    }, []);
  }

  create(newContact: any): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/contact`, newContact);
  }
}
